'use client'
import { useState, useEffect } from "react";

export default function Hero() {
  const images = [
    "assets/images/Olympia_IMG/Banners/1-new.png",
    "assets/images/Olympia_IMG/Banners/2-new.png",
    "assets/images/Olympia_IMG/Banners/3-new.png",
  ];

  const content = [
    {
      subtitle: "Excellence in Research",
      title: "High Laboratory Quality Products",
      text: "Welcome to our research center where innovation meets practical solutions.",
    },
    {
      subtitle: "Trusted by Professionals",
      title: "Reliable & High Quality",
      text: "We bring together diverse expertise to tackle global issues in science and medicine.",
    },
    {
      subtitle: "",
      title: "  ",
      text: "     ",
    },
  ];

  const [currentIndex, setCurrentIndex] = useState(0);
  const [opacity, setOpacity] = useState(1);

  useEffect(() => {
    const interval = setInterval(() => {
      setOpacity(0); // Fade out
      setTimeout(() => {
        setCurrentIndex((prev) => (prev + 1) % images.length);
        setOpacity(1); // Fade in
      }, 1000);
    }, 6000);

    return () => clearInterval(interval);
  }, [images.length]);

  return (
    <div className="hero-wrapper hero-3" id="hero">
      <img
        src={images[currentIndex]}
        alt={`Slide ${currentIndex + 1}`}
        className="hero-image"
        style={{ opacity: opacity, transition: "opacity 1s ease-in-out" }}
      />

      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="hero-style3 left-text">
              <h6 className="hero-subtitle title-animation">{content[currentIndex].subtitle}</h6>
              <h1 className="hero-title title-animation">{content[currentIndex].title}</h1>
              <p className="hero-text title-animation">{content[currentIndex].text}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
